<div class="dialogContainer" [ngClass]="{ 'visible' : showModal }" [attr.inert]="showModal ? null : ''">
  <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="feeEditorDialogTitle">
    <div class="grid-container">
      <div class="grid-x" [formGroup]="form" role="form">
        <div class="cell large-9 medium-9 small-9 bold text-align-left">
          <h3 #dialogHeading id="feeEditorDialogTitle" tabindex="-1">Edit Fee</h3>
        </div>
        <div class="cell large-3 medium-3 small-3">
          <span class="minor-margin-right">
            <button class="button" (click)="save()" [disabled]="disableSave">Save</button>
          </span>
          <span>
            <button class="button" (click)="close()">Close</button>
          </span>
        </div>
        <div class="cell large-3 medium-3 small-3 text-align-right padding-right">
          <label class="bold" for="displayName">Display Name:</label>
        </div>
        <div class="cell large-9 medium-9 small-9 text-align-left padding-left">
          <span id="displayName">{{form.get('displayName').value}}</span>
        </div>
        <div class="cell large-3 medium-3 small-3 text-align-right">
          <label class="bold" for="effectiveFrom">Effective From:*</label>
          @if (form.get('effectiveFrom').dirty && form.get('effectiveFrom').hasError('required')) {
            <small class="error">
              Effective From Date is required
            </small>
          }
        </div>
        <div class="cell large-3 medium-3 small-3 padding-left">
          <common-date-picker [id]="'effectiveFrom'" [controlName]="'effectiveFrom'" [formGroup]="form?.get('effectiveFrom')"></common-date-picker>
        </div>
        <!--<div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="effectiveTo">Effective To:</label>
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <common-date-picker id="effectiveTo" [disabled]="true" [controlName]="'effectiveTo'" [formGroup]="form?.get('effectiveTo')"></common-date-picker>
      </div>
      <div class="cell large-12 medium-12 small-12 bold italic shrink-font">
        {{dateHelp}}
      </div>-->
      <div class="cell large-6 medium-6 small">
        &nbsp;
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label for="feeAmount">
          <span class="bold">
            Fee Amount:
          </span>
          <help-text [attr.aria-described-by]="'help'" [helpText]="matrixHelp"></help-text>
          <span id="help" class="show-for-sr">{{matrixHelp}}</span>
        </label>
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="number" min="0" step="0.01" formControlName="feeAmount" />

      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="expediteFee">Expedite Fee:</label>
        @if (form.get('expediteFee').dirty && form.get('expediteFee').hasError('min')) {
          <small class="error">
            Expedite Fee must be greater than or equal to zero.
          </small>
        }
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="number" min="0" step="0.01" formControlName="expediteFee" />
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="department">Department:*</label>
        @if (form.get('department').dirty && form.get('department').hasError('required')) {
          <small class="error">
            Department is required
          </small>
        }
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="text" formControlName="department" />
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="fund">Fund:*</label>
        @if (form.get('fund').dirty && form.get('fund').hasError('required')) {
          <small class="error">
            Fund is required
          </small>
        }
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="text" formControlName="fund" />
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="ali">ALI:*</label>
        @if (form.get('ali').dirty && form.get('ali').hasError('required')) {
          <small class="error">
            ALI is required
          </small>
        }
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="text" formControlName="ali" />
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="program">Program:*</label>
        @if (form.get('program').dirty && form.get('program').hasError('required')) {
          <small class="error">
            Program is required
          </small>
        }
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="text" formControlName="program" />
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="revenueSourceCode">Revenue Source Code:*</label>
        @if (form.get('revenueSourceCode').dirty && form.get('revenueSourceCode').hasError('required')) {
          <small class="error">
            Revenue Source Code is required
          </small>
        }
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="text" formControlName="revenueSourceCode" />
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="reporting">Reporting:</label>
      </div>
      <div class="cell large-3 medium-3 small-3 padding-left">
        <input type="text" formControlName="reporting" />
      </div>

      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="accountDescription">Account Description:*</label>
        @if (form.get('accountDescription').dirty && form.get('accountDescription').hasError('required')) {
          <small class="error">
            Account Description is required
          </small>
        }
      </div>
      <div class="cell large-9 medium-9 small-9 padding-left">
        <input type="text" formControlName="accountDescription" />
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <label class="bold" for="accountDescription">Legal Reference:*</label>
        @if (form.get('legalReference').dirty && form.get('legalReference').hasError('required')) {
          <small class="error">
            Legal Reference is required
          </small>
        }
      </div>
      <div class="cell large-9 medium-9 small-9 padding-left">
        <input type="text" formControlName="legalReference" />
      </div>
      <div class="cell small-6 medium-6 large-6">
        <label class="bold">Fee Matrix:</label>
      </div>
      <!--<div class="cell small-3 medium-3 large-3">
      <button class="button" aria-described-by="addMatrix" (click)="addMatrixEntry()">Add</button>
      <span class="show-for-sr" id="addMatrix">Add New Matrix Item</span>
    </div>-->
    <div class="cell small-6 medium-6 large-6">
      <label class="bold">Fee Type:</label>
    </div>
    <!--<div class="cell small-3 medium-3 large-3">
    <button class="button" aria-described-by="addType" (click)="addTypeEntry()">Add</button>
    <span class="show-for-sr" id="addType">Add New Type Item</span>
  </div>-->
  <div class="cell large-6 medium-6 small-6" formArrayName="feeMatrix">
    <div class="matrix-column" style="display: flex; flex-direction: column;">
      <div class="matrix-display">
        <span class="padding-right bold matrix-label">
          Code
          <help-text [attr.aria-described-by]="'entryHelp'" [helpText]="matrixEntryHelp" [position]="'right'"></help-text>
          <span id="entryHelp" class="show-for-sr">{{matrixEntryHelp}}</span>
        </span>
        <span class="padding-left bold matrix-label">
          Amount ($)
        </span>

      </div>
      @for (item of feeMatrix.controls; track item; let i = $index) {
        <div class="matrix-display">
          <span class="padding-right matrix-row" [formGroupName]="i">
            <span class="padding-right">
              <input type="text" [id]="'code_' + i" formControlName="matrixCode" />
            </span>
            <span class="padding-right">
              <input type="number" [id]="'value_' + i" min="0.00" step="0.01" formControlName="matrixAmount" />
            </span>
            <!--<button class="button" [attr.aria-describedby]="'desc' + i" (click)="removeMatrix(i)">
            <svg-icon class="white" aria-hidden="true" icon="icon-trash"></svg-icon>
          </button>-->
          <!--<span class="show-for-sr" [id]="'desc' + i">Remove Matrix Item {{item?.get('matrixCode').value}}</span>-->
        </span>
      </div>
    }
  </div>
</div>
<div class="cell small-6 medium-6 large-6" formArrayName="feeTypes">
  @for (item of feeTypes.controls; track item; let i = $index) {
    <div class="matrix-display" style="display: flex;">
      <span class="padding-right" [formGroupName]="i">
        <input type="text" [id]="'type_' + i" formControlName="typeValue" />
      </span>
      <!--<button class="button" [attr.aria-describedby]="'desc' + i" (click)="removeType(i)">
      <svg-icon class="white" aria-hidden="true" icon="icon-trash"></svg-icon>
    </button>-->
    <!--<span class="show-for-sr" [id]="'desc' + i">Remove Type Item {{item?.get('typeValue').value}}</span>-->
  </div>
}

</div>
</div>
</div>
<div style="text-align: left;">


<ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="feeData" [excelStyles]="excelStyles" [statusBar]="statusBar" aria-label="Fee Editor"></ag-grid-angular>
</div>
</div>
</div>
